import { render, staticRenderFns } from "./TextColor.vue?vue&type=template&id=27aaf868&scoped=true&"
import script from "./TextColor.vue?vue&type=script&lang=js&"
export * from "./TextColor.vue?vue&type=script&lang=js&"
import style0 from "./TextColor.vue?vue&type=style&index=0&id=27aaf868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aaf868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27aaf868')) {
      api.createRecord('27aaf868', component.options)
    } else {
      api.reload('27aaf868', component.options)
    }
    module.hot.accept("./TextColor.vue?vue&type=template&id=27aaf868&scoped=true&", function () {
      api.rerender('27aaf868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/TextColor.vue"
export default component.exports